webpackJsonp([88],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的banner管理ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入banner管理名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })],
  app_types: [{
    type: 'array',
    required: true,
    min: 1,
    message: '请选择上架APP',
    trigger: 'change'
  }]
};

/***/ }),

/***/ 2509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_banner_rules_js__ = __webpack_require__(2107);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_2__app_banner_rules_js__["a" /* formRules */],
      form: {
        app_types: [1],
        img: '',
        url: '',
        priority: null,
        upshelftime: '',
        downshelftime: '',
        daterange: []
      }
    };
  },

  computed: Vuex.mapState({
    appTypeList: function appTypeList(state) {
      return state.order && state.order.options && state.order.options.app_type_list || [];
    }
  }),
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    allowedAppTypeValues: function allowedAppTypeValues() {
      return this.appTypeList.map(function (item) {
        return Number(item.value);
      });
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getAppBannerDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        data.daterange = [data.upshelftime, data.downshelftime];
        data.app_types = _this.parseAppTypes(data.app_types);
        filter.setLoop(_this.form, data);
      });
    },
    parseAppTypes: function parseAppTypes(raw) {
      var allowed = this.allowedAppTypeValues();
      var fallback = allowed.length ? [allowed[0]] : [1];
      if (raw === undefined || raw === null || raw === '') {
        return fallback;
      }
      // 接口返回逗号串；表单 checkbox-group 使用 number[]
      var types = String(raw).split(',').map(function (s) {
        return Number(String(s).trim());
      }).filter(function (v) {
        return allowed.indexOf(v) !== -1;
      });
      return types.length ? types : fallback;
    },
    getForm: function getForm() {
      var form = filter.copyJson(this.form);
      form.upshelftime = form.daterange[0];
      form.downshelftime = form.daterange[1];
      var allowed = this.allowedAppTypeValues();
      var types = (form.app_types || []).map(Number).filter(function (v) {
        return allowed.indexOf(v) !== -1;
      });
      types.sort(function (a, b) {
        return a - b;
      });
      // 提交给 Core 的 app_types 固定为逗号串
      form.app_types = types.join(',');
      return form;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createAppBannerData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', {
          type: 'success'
        }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/app-banner/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateAppBannerData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/app-banner/table/' });
        });
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.form.img = '';
    },
    onChangeFile: function onChangeFile(file, fileList) {
      var isExcel = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      var isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!');
        this.$refs.upload.clearFiles();
        return false;
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!');
        this.$refs.upload.clearFiles();
        return false;
      }
      this.OnUploadFile(file.raw);
    },
    OnUploadFile: function OnUploadFile(file) {
      var _this5 = this;

      var formData = new FormData();
      formData.append('file', file);
      return request.common('uploadAppBanner', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this5.form.img = data;
        _this5.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
      });
    }
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBannerForm_vue__ = __webpack_require__(2509);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36278259_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBannerForm_vue__ = __webpack_require__(3146);
function injectStyle (ssrContext) {
  __webpack_require__(3140)
  __webpack_require__(3142)
  this["$style"] = __webpack_require__(3144)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36278259"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBannerForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36278259_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBannerForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3140:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0197fb3c", content, true, {});

/***/ }),

/***/ 3141:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".avatar-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload:hover{border-color:#409eff}.avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar{width:178px;height:178px;display:block;-o-object-fit:cover;object-fit:cover}", "", {"version":3,"sources":["/workspace/src/views/app-banner/pages/AppBannerForm.vue"],"names":[],"mappings":"AACA,4BAA4B,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CACvH,AACD,kCAAkC,oBAAoB,CACrD,AACD,sBAAsB,eAAe,cAAc,YAAY,aAAa,kBAAkB,iBAAiB,CAC9G,AACD,QAAQ,YAAY,aAAa,cAAc,oBAAoB,gBAAgB,CAClF","file":"AppBannerForm.vue","sourcesContent":["\n.avatar-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.avatar-uploader .el-upload:hover{border-color:#409EFF\n}\n.avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center\n}\n.avatar{width:178px;height:178px;display:block;-o-object-fit:cover;object-fit:cover\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3142:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("47b5ad30", content, true, {});

/***/ }),

/***/ 3143:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".banner-img-hint[data-v-36278259]{margin:8px 0 0;font-size:12px;color:#909399;line-height:1.5}", "", {"version":3,"sources":["/workspace/src/views/app-banner/pages/AppBannerForm.vue"],"names":[],"mappings":"AACA,kCAAkC,eAAe,eAAe,cAAc,eAAe,CAC5F","file":"AppBannerForm.vue","sourcesContent":["\n.banner-img-hint[data-v-36278259]{margin:8px 0 0;font-size:12px;color:#909399;line-height:1.5\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3144:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("58842306", content, true, {});

/***/ }),

/***/ 3145:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AppBannerForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/app-banner/table"}},[_vm._v("banner列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"上架APP","prop":"app_types"}},[_c('el-checkbox-group',{model:{value:(_vm.form.app_types),callback:function ($$v) {_vm.$set(_vm.form, "app_types", $$v)},expression:"form.app_types"}},_vm._l((_vm.appTypeList),function(item){return _c('el-checkbox',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片链接","prop":"url"}},[_c('el-input',{model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", $$v)},expression:"form.url"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"优先级","prop":"priority"}},[_c('el-input',{model:{value:(_vm.form.priority),callback:function ($$v) {_vm.$set(_vm.form, "priority", $$v)},expression:"form.priority"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上下架时间","prop":"daterange"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"上架时间","end-placeholder":"下架日期","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.form.daterange),callback:function ($$v) {_vm.$set(_vm.form, "daterange", $$v)},expression:"form.daterange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片","prop":"img"}},[_c('div',[_c('el-upload',{ref:"upload",staticClass:"avatar-uploader",attrs:{"auto-upload":false,"action":"","show-file-list":false,"on-change":_vm.onChangeFile,"on-remove":_vm.handleRemove}},[(_vm.form.img)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.form.img}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),_c('p',{staticClass:"banner-img-hint"},[_vm._v("建议尺寸：1372*500，大小不超过2M")])],1)])],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v(_vm._s(_vm.id ? '修改' : '添加'))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/app-banner-form.ceb3e2b27d50aff146b7.js